var _ = require('underscore');
var he = require('he');

function normalTag(tagName, tagContent) {
    return '<' + tagName + '>' + tagContent + '</' + tagName + '>';
}

function selfClosingTag(tagName) {
    return '<' + tagName + ' />';
}

function parse(node, level, allowedTags) {
    var tagName = null;

    if (node.nodeType === node.TEXT_NODE) {
        var textContent = he.encode(node.textContent);
        return level === 0 ? normalTag('p', textContent) : textContent;
    } else if (node.tagName.toLowerCase() == 'br') {
        return selfClosingTag('br');
    } else {
        var tagName = node.tagName.toLowerCase();
        var isAllowed = allowedTags.indexOf(node.tagName.toLowerCase()) > -1;
        var textContent = _.map(node.childNodes, function(childNode) {
            return parse(childNode, isAllowed ? level + 1 : level, allowedTags);
        }).join('');

        return isAllowed ? normalTag(tagName, textContent) : textContent;
    }
}

function htmlParser(aHTMLString, allowedTags) {
    var el = document.createElement('div');
    el.innerHTML = aHTMLString;
    var text = _.map(el.childNodes, function(childNode) {
        return parse(childNode, 0, allowedTags);
    }).join('');
    return text;
}

module.exports = htmlParser;
